import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "../../redux-toolkit/features/auth/authSlice";
import { rememberPostLoginRedirect } from "../../utils/postLoginRedirect";

const PersistLogin = () => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();

  if (!token) {
    rememberPostLoginRedirect(`${location.pathname}${location.search}`);
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default PersistLogin;
